import React from 'react'
import { Download, SadFace } from '../../assets/icons'
import to from 'await-catch'
import { downloadExamResult } from '../../api'
import {
	OrdersContainer,
	CardContainer,
	CardContent,
	DownloadButton,
	OrdersWrapper
} from './styled'
import { LinkText, Text1, Text2 } from '../../styled/generics'
import theme from '../../styled/theme'
import { resetLabsFilters } from '../../actions'
import { connect } from 'react-redux'
import EmptyState from '../emptyState'
import { Bold } from '../../pages/private/EmergencyRoom/styled'

const ResultCard = ({
	result,
	fields,
	isCarousel = false,
	onDownload,
	renderDownloads,
	renderField,
	allTitlesBold
}) => {
	const handleDownload = async e => {
		e.preventDefault()
		const request = { actId: result.actId }
		const [err, { data } = {}] = await to(downloadExamResult(request))
		if (!err && data) {
			const link = document.createElement('a')
			link.href = data
			link.target = '_blank'
			link.click()
		}
	}

	return (
		<CardContainer isCarousel={isCarousel}>
			<CardContent>
				{fields &&
					fields.map(field =>
						field.key === 'download' ||
						field.key === 'informe' ||
						field.key === 'descargas' ? null : renderField ? (
							renderField(field, result)
						) : (
							<Text2
								key={field.key}
								size={field.size || '16px'}
								color={theme.colors.text.secondaryText}
							>
								{allTitlesBold ? (
									<>
										<Bold>{field.label ? `${field.label}: ` : ''}</Bold>
										{result[field.key]}
									</>
								) : (
									`${field.label ? `${field.label}: ` : ''}${result[field.key]}`
								)}
							</Text2>
						)
					)}
				{renderDownloads && renderDownloads(result)}
			</CardContent>
			{fields && fields.some(f => f.key === 'download' || f.key === 'informe') && !renderDownloads && (
				<DownloadButton href="#" onClick={handleDownload}>
					<Download />
					<LinkText size={'16px'}>Descargar</LinkText>
				</DownloadButton>
			)}
		</CardContainer>
	)
}

const ResultsList = ({
	results = [],
	fields,
	isCarousel,
	onDownload,
	renderDownloads,
	renderField,
	isSearch,
	allTitlesBold = false,
	style
}) => {
	const resultsList = Array.isArray(results)
		? results
		: results && Array.isArray(results.items)
		? results.items
		: []

	return (
		<OrdersWrapper style={style}>
			<OrdersContainer theme={theme} isCarousel={isCarousel}>
				{resultsList.map(result => (
					<ResultCard
						isCarousel={isCarousel}
						key={result.id}
						result={result}
						fields={fields}
						onDownload={onDownload}
						renderDownloads={renderDownloads}
						renderField={renderField}
						allTitlesBold={allTitlesBold}
					/>
				))}

				{resultsList.length === 0 && (
					<EmptyState actionButton={resetLabsFilters} isSearch={isSearch} />
				)}
			</OrdersContainer>
		</OrdersWrapper>
	)
}

const mapDispatchToProps = {
	resetLabsFilters
}

export default connect(null, mapDispatchToProps)(React.memo(ResultsList))
